import { ICDV3ViewItem } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItem';
import { eTitleFees } from 'ui-toolkit/enums/eTitleFees';
import { eUnderwriter } from 'ui-toolkit/enums/eUnderwriter';
import { eCDV3ItemTypes } from '../../../ui-toolkit/enums/eCDV3ItemTypes';

//Standard non-removable (UX-only) fees
const standardNonRemovableCDItemTypes = [
  eCDV3ItemTypes.percentage_of_loan_amount,
  eCDV3ItemTypes.escrow_at_closing,
  eCDV3ItemTypes.interest_prepayment,
  eCDV3ItemTypes.non_interest_prepayment,
  eCDV3ItemTypes.aggregate_adjustment,
  eCDV3ItemTypes.buyer_reimbursement_to_seller,
  eCDV3ItemTypes.buyer_reimbursement_from_seller,
  eCDV3ItemTypes.seller_excess_deposit,
  eCDV3ItemTypes.buyer_deposit,
];

//Extra fees to make non-removable for Underwriter American Digital
const americanDigitalNonRemovableTitleFees = [
  eTitleFees.lenders_policy,
  eTitleFees.standard_owners_policy,
  eTitleFees.cpl_borrower,
  eTitleFees.cpl_borrower,
  eTitleFees.cpl_buyer,
  eTitleFees.cpl_seller,
  eTitleFees.cpl_lender,
  eTitleFees.tieff_lenders_policy,
  eTitleFees.tieff_owners_policy,
];

export default function computeShowRemove(item: ICDV3ViewItem, underwriter?: eUnderwriter) {
  const isStandardNonRemovableCDItem = standardNonRemovableCDItemTypes.includes(item.type);
  let isAmericanDigitalNonRemovableCDItem =
    item.type === eCDV3ItemTypes.title_fee &&
    item.sub_type &&
    americanDigitalNonRemovableTitleFees.includes(item.sub_type);
  return (
    !isStandardNonRemovableCDItem &&
    (underwriter === eUnderwriter.AmericanDigital ? !isAmericanDigitalNonRemovableCDItem : true)
  );
}
